<div class="box ml-2  mr-2" >
  <div class="box-header">

    <div class="box-body">
      <form [formGroup]="msrForm">
        <div class="col form">
          <div class="row" style="justify-content: center;">


            <div class="col">


              <mat-form-field appearance="outline">
                <mat-label>{{'From Date' | translate}}</mat-label>
                <input matInput [max]="maxDate" [matDatepicker]="picker" formControlName="fromDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>




            </div>

            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{'To Date' | translate}}</mat-label>
                <input matInput  [max]="maxDate" [matDatepicker]="todate" formControlName="toDate">
                <mat-datepicker-toggle matSuffix  [for]="todate"></mat-datepicker-toggle>
                <mat-datepicker #todate></mat-datepicker>
              </mat-form-field>


              <!-- <button mat-raised-button  class="ml-2 mt-2 ml-sm-auto" [disabled]="!poSummaryForm.valid" (click)="getPOOrderData()">
              {{'Filter' | translate}}
            </button> -->

          </div>

          @if (userData.roleId<4) {
            <div class="col">
              <!-- <mat-form-field appearance="outline">
              <mat-label>{{'DC Location' | translate}}</mat-label>
              <input matInput maxlength="6" formControlName="storeNumber" (keyup.enter)="getPOOrderData()" />
            </mat-form-field> -->
            <mat-form-field class="example-full-width" appearance="outline" >
              <mat-label>{{'DC Location' | translate}}</mat-label>
              <input type="text" matInput formControlName="dcNumber" [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                @for (dc of user.dcLocations; track dc) {
                  <mat-option [value]="dc.dcNumber">
                    {{dc.dcLocation}} - {{dc.dcName}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        }











      </div>
      <div class="row" style="justify-content: center;">
        <div class="col">
          <section class="check-box-section" >
            <!-- <mat-checkbox class="check-box-section"  formControlName="msrPendingSignature"  (change)="onChangeReportType($event)">Pending Signature</mat-checkbox>-->
            <mat-checkbox class="check-box-margin"  formControlName="overdue"  >{{'Overdue' | translate}}</mat-checkbox>

          </section>
        </div>

        <div class="col">
          <section class="check-box-section" >
            <!-- <mat-checkbox class="check-box-section"  formControlName="msrPendingSignature"  (change)="onChangeReportType($event)">Pending Signature</mat-checkbox>-->

            <mat-checkbox class="check-box-margin"   formControlName="late"  >{{'Late' | translate}}</mat-checkbox>
          </section>
        </div>

        <div class="col">

          <button mat-raised-button  class="ml-2 mt-3 mb-4 ml-sm-auto" (click)="openMSRReport()"  [disabled]="!msrForm.valid">
            {{'Filter' | translate}}
          </button>
        </div>
        <!-- <div class="col" *ngIf="userData.roleId<4"></div>-->

      </div>

    </div>
  </form>
</div>


</div>


</div>